import { Button, DialogActions, Stack } from '@mui/material';
import { COMMON_STRING } from '@/constants/dictionary';
import { API_METHOD } from '@/service/constants';

interface EvaluationSourceButtonsProps {
  onClose: VoidFunction;
  onSubmit: (
    action: API_METHOD.POST | API_METHOD.PUT | API_METHOD.DELETE,
  ) => Promise<void>;
  isSubmitDisabled?: boolean;
  isEditMode?: boolean;
}
export const EvaluationSourceButtonsSet = ({
  onSubmit,
  onClose,
  isEditMode,
  isSubmitDisabled,
}: EvaluationSourceButtonsProps) => {
  return (
    <DialogActions sx={{ p: 0 }}>
      <Stack direction='row' gap={2}>
        <Button onClick={onClose} variant='text'>
          {COMMON_STRING.CLOSE}
        </Button>
        <Button
          disabled={isSubmitDisabled}
          variant='contained'
          onClick={() =>
            onSubmit(isEditMode ? API_METHOD.PUT : API_METHOD.POST)
          }
        >
          {isEditMode ? COMMON_STRING.UPDATE : COMMON_STRING.ADD}
        </Button>
      </Stack>
    </DialogActions>
  );
};
